"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scopeAppropriateImage = scopeAppropriateImage;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSimpleSurveyor = _interopRequireDefault(require("@mapbox/react-simple-surveyor"));

var _appropriateImagesGetUrl = _interopRequireDefault(require("@mapbox/appropriate-images-get-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function scopeAppropriateImage(imageConfig, options) {
  options = options || {};
  var transformUrl = options.transformUrl !== undefined ? options.transformUrl : function (x) {
    return x;
  };
  var hiResRatio = options.hiResRatio !== undefined ? options.hiResRatio : 1.3;

  var AppropriateImage = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(AppropriateImage, _React$PureComponent);

    var _super = _createSuper(AppropriateImage);

    function AppropriateImage() {
      _classCallCheck(this, AppropriateImage);

      return _super.apply(this, arguments);
    }

    _createClass(AppropriateImage, [{
      key: "render",
      value: function render() {
        var _this = this;

        var url = (0, _appropriateImagesGetUrl["default"])({
          imageId: this.props.imageId,
          availableWidth: this.props.width,
          imageConfig: imageConfig,
          hiResRatio: hiResRatio
        });
        url = transformUrl(url);
        var elementProps = Object.keys(this.props).reduce(function (result, key) {
          // All prop types we don't want to pass to the element should fail this condition.
          if (!/^(imageId|width|background|backgroundPosition|backgroundSize)$/.test(key)) {
            result[key] = _this.props[key];
          }

          return result;
        }, {});

        if (!this.props.background) {
          return /*#__PURE__*/_react["default"].createElement("img", _extends({
            src: url
          }, elementProps));
        }

        var backgroundStyle = {
          backgroundImage: "url(\"".concat(url, "\")"),
          backgroundRepeat: 'no-repeat',
          backgroundPosition: this.props.backgroundPosition,
          backgroundSize: this.props.backgroundSize,
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };

        if (elementProps.style) {
          Object.keys(elementProps.style).forEach(function (key) {
            backgroundStyle[key] = elementProps.style[key];
          });
          delete elementProps.style;
        }

        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, this.props.imageProps, {
          style: backgroundStyle
        }));
      }
    }]);

    return AppropriateImage;
  }(_react["default"].PureComponent);

  AppropriateImage.propTypes = {
    imageId: _propTypes["default"].string.isRequired,
    background: _propTypes["default"].bool,
    backgroundPosition: _propTypes["default"].string,
    backgroundSize: _propTypes["default"].string,
    // Provided by survey
    width: _propTypes["default"].number.isRequired
  };
  AppropriateImage.defaultProps = {
    background: false,
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  };
  return (0, _reactSimpleSurveyor["default"])(AppropriateImage);
}